<template>
	<component v-if="visible" :is="rootTag" :class="['fd-text', clazz, errorClass]" :style="style">{{ textContent }}</component>
</template>

<script setup lang="ts">
import usePart, {type PartProps, partProps} from "../Part";
import type {Text} from "@t/fd/fixed/Text";
import {computed} from "vue";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const tx = computed<Text>(() => props.part as Text);
const { visible, valueExpression, clazz, style, errorLevel } = usePart(props);

const textContent = valueExpression("value", "ex");

const rootTag = computed(() => {
  return tx.value.tag ? tx.value.tag : "span";
});

const errorClass = computed(() => {
   const l = errorLevel.value;
   if (l === "SEVERE") return "invalid-text";
   else if (l === "WARNING") return "warn-text";
   else if (l === "INFO") return "info-text";
});

</script>
<style>
.fd-text {
	color: var(--fg);
}
.fd-text.invalid-text {
    color: var(--input-error-fg);
}
.fd-text.warn-text {
    color: var(--warn-fg);
}
.fd-text.info-text {
    color: var(--green);
}
</style>
